import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { AnnualNetIncome } from '../../../../../core';

@JsonConverter
export class AnnualNetIncomeAdapter implements JsonCustomConvert<AnnualNetIncome | undefined> {
    serialize(annualNet: AnnualNetIncome): any | undefined {
        return annualNet ? String(annualNet) : undefined;
    }

    deserialize(annualNet: any): AnnualNetIncome | undefined {
        switch (annualNet) {
            case '1B':
                return AnnualNetIncome.LESS_30000;
            case '2B':
                return AnnualNetIncome.BETWEEN_30001_60000;
            case '3B':
                return AnnualNetIncome.BETWEEN_60001_100000;
            case '4B':
                return AnnualNetIncome.BETWEEN_100001_150000;
            case '5B':
                return AnnualNetIncome.MORE_150000;
            default:
                return undefined;
        }
    }
}
